<template>
  <div class="breadcrumb">
    <div v-if="home" class="nav" @click="handleClick(home, 0)">{{home.name}}</div>
    <div v-for="(item, i) in datas" :key="item.id">
      <i class="el-icon-arrow-right" style="padding-right: 5px" /> <span class="nav" @click="handleClick(item, i + 1)">{{item.name}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    home: Object,
    datas: Array
  },
  methods: {
    handleClick(item, level) {
      this.$emit('onNav', item, level)
    }
  }
}
</script>

<style lang='scss' scoped>
.breadcrumb {
  padding: 12px;
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
}
.nav {
  cursor: pointer;
  padding-right: 5px;
  color:  #3b9cd9;
}
</style>
